import { isAndroid, isIOS } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import {
    Button,
    Modal,
    ModalComponent,
    ModalProps,
} from '@speeki/global-ui-components';

interface DownloadSpeekiAppModalProps
    extends Pick<ModalProps, 'onClose' | 'open'> {}

export const DownloadSpeekiAppModal = ({
    onClose,
    open,
}: DownloadSpeekiAppModalProps) => {
    const { t } = useTranslation();

    const redirectToAppDownload = () => {
        if (isAndroid) {
            window.location.href =
                'https://play.google.com/store/apps/details?id=com.speeki.nicole';
        }
        if (isIOS) {
            window.location.href =
                'https://apps.apple.com/pl/app/speeki/id1543895442';
        }
    };

    return (
        <ModalComponent
            onClose={onClose}
            open={open}
            preventCloseEsc
            preventCloseOutside
            width={648}
        >
            <Modal.Content>
                <Modal.TitleSecondary center>
                    {t('INSTALL_SPEEKI_APP')}
                </Modal.TitleSecondary>
                <Modal.Description>
                    {t('INSTALL_SPEEKI_APP_DESCRIPTION')}
                </Modal.Description>
            </Modal.Content>
            <Modal.Footer>
                <Modal.ButtonsWrapper>
                    <Button
                        minWidth={0}
                        onClick={onClose}
                        testId="button_cancel"
                        variant={'secondary'}
                    >
                        {t('CANCEL')}
                    </Button>
                    <Button
                        minWidth={0}
                        onClick={redirectToAppDownload}
                        testId="button_install"
                        variant={'primary'}
                    >
                        {t('INSTALL')}
                    </Button>
                </Modal.ButtonsWrapper>
            </Modal.Footer>
        </ModalComponent>
    );
};
